/** Shared shop kiosk pilot login — redirect to kiosk when this user is logged in. */
export const KIOSK_PILOT_EMAIL = 'metals@fabworksga.com';

/** True when the logged-in user is the shared shop kiosk account (PIN terminal session). */
export function isKioskPilotUser(user) {
  if (!user?.email) return false;
  return user.email.trim().toLowerCase() === KIOSK_PILOT_EMAIL.trim().toLowerCase();
}
